/* Copyright (c) 2020-present CloudIO Inc */

import { Item } from '../../registry/Component.type';

export const page: {
  root: Item<'Page'>;
  localDataStore: Item<'LocalDataStore'>;
  flexItem2: Item<'FlexItem'>;
  angularGauge: Item<'AngularGauge'>;
  flexItem1: Item<'FlexItem'>;
  flexItem: Item<'FlexItem'>;
  flexPanel: Item<'FlexPanel'>;
  emptySpacer: Item<'EmptySpacer'>;
  emptySpacer1: Item<'EmptySpacer'>;
} = {
  emptySpacer: {
    children: [],
    itemId: 'emptySpacer',
    parent: 'flexItem2',
    props: {},
    type: 'EmptySpacer',
  },
  emptySpacer1: {
    children: [],
    itemId: 'emptySpacer1',
    parent: 'flexItem',
    props: {},
    type: 'EmptySpacer',
  },
  flexItem: {
    children: ['emptySpacer1'],
    itemId: 'flexItem',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexItem1: {
    children: ['angularGauge'],
    itemId: 'flexItem1',
    parent: 'flexPanel',
    props: {
      backgroundColor: 'paper',
      max: 600,
      min: 600,
      padding: {
        all: 16,
      },
      sizeType: 'minmax',
    },
    type: 'FlexItem',
  },
  flexItem2: {
    children: ['emptySpacer'],
    itemId: 'flexItem2',
    parent: 'flexPanel',
    props: {},
    type: 'FlexItem',
  },
  flexPanel: {
    children: ['flexItem2', 'flexItem1', 'flexItem'],
    itemId: 'flexPanel',
    parent: 'root',
    props: {
      renderAs: 'columns',
    },
    type: 'FlexPanel',
  },
  angularGauge: {
    children: [],
    itemId: 'angularGauge',
    parent: 'flexItem1',
    props: {
      dsalias: 'test',
      valueAttribute: 'score',
      keyAttribute: 'id',
      labelAttribute: '',
      orderByAttribute: '',
      functionType: 'Avg',
      caption: {
        type: 'text',
        value: 'Customer Satisfaction Score',
      },
      subCaption: {
        type: 'text',
        value: 'Last Quarter',
      },
      lowerLimit: {
        type: 'text',
        value: '0',
      },
      upperLimit: {
        type: 'text',
        value: '100',
      },
      showValue: true,
      showTickMarks: true,
      showTickValues: true,
      showBorder: false,
      placeTicksInside: false,
      placeValuesInside: false,
      forceDecimals: false,
      numberPrefix: '',
      numberSuffix: '%',
      decimals: 1,
      decimalSeparator: '.',
      thousandSeparator: ',',
      thousandSeparatorPosition: '3',
      dialValue: {
        type: 'text',
        value: '',
      },
      dialValueFontSize: 24,
      chartHeight: 300,
      chartWidth: 300,
      exportEnabled: false,
      exportFileName: 'customer_satisfaction_gauge',
      doNotPrefetch: false,
      borderThickness: 0,
      tickValueStep: 10,
      majorTMHeight: '10',
      minorTMNumber: '4',
      majorTMNumber: '5',
      gaugeOuterRadius: '',
      gaugeInnerRadius: '',
      gaugeStartAngle: '',
      gaugeEndAngle: '',
      plotToolText: 'Score: $dataValue%',
      darkBackGround: false,
      showTrendLine: false,
      startValue: {
        type: 'text',
        value: '0',
      },
      thickness: 2,
      dashedLine: false,
      valueInside: false,
      lineColor: '#000000',
      displayValue: '',
      trendValueDistance: '10',
      gaugeFillColor: {
        type: 'text',
        value: '',
      },
      bgColor: {
        type: 'text',
        value: '',
      },
      dialFillColor: {
        type: 'text',
        value: '#29C3BE',
      },
      majorTMColor: {
        type: 'text',
        value: '',
      },
      minorTMColor: {
        type: 'text',
        value: '',
      },
    },
    type: 'AngularGauge',
  },

  localDataStore: {
    children: [],
    itemId: 'localDataStore',
    parent: 'root',
    props: {
      alias: 'test',
      dataFormat: 'json',
      dataSource: 'test',
      jsonData: JSON.stringify([
        { id: 1, score: 67 },
        { id: 2, score: 72 },
        { id: 3, score: 65 },
        { id: 4, score: 71 },
        { id: 5, score: 68 },
      ]),
    },
    type: 'LocalDataStore',
  },
  root: {
    children: ['localDataStore', 'flexPanel'],
    itemId: 'root',
    parent: 'root',
    props: {
      windowTitle: {
        type: 'text',
        value: 'CloudIO Help',
      },
    },
    type: 'Page',
  },
};
